import React from 'react';
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import CfdiContacto from '../../Catalogos/clientes/cfdi/CfdiContacto'
import Facturas from './PagoFacturasTabla'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import DescargarDeposito from './DescargarDeposito'
import Snackbar from '../../../components/alert/Snackbar';
import { DialogComponent } from "../../../components/dialog/DialogComponent";
import ACCESS from '../../../ACCESS';

class Deposito extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'pago-deposito', saveUrl: 'pago-deposito/save', backUrl: '/Ventas/Pagos' },
      new Form([
        Form.Field('number', 'importe', 'Importe', '', [Validators.required], 12, [], [], [], false, true),
        Form.Field('number', 'restante', 'Restante por aplicar', '', [], 12, [], [], [], false, true),
        Form.Field('select', 'id_cliente', 'Cliente', '', [Validators.required], 12),
        /* Form.Field('select', 'id_forma_pago', 'Forma de Pago', '', [Validators.required], 12), */
        Form.Field('select', 'id_banco', 'Banco', '', [], 12),
        Form.Field('text', 'no_cuenta', 'No. Cuenta', '', [], 12),
        Form.Field('text', 'clabe', 'Clabe', '', [], 12),
        Form.Field('text', 'no_cheque', 'No. Cheque', '', [], 12),
        Form.Field('text', 'descripcion', 'Descripcion', '', [], 12),
      ], ['Guardar'], 'Control de depositos'), this.formData
    )
    if (this.props.id_deposito) {
      this.LoadPreds(this.props.id_deposito)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id_deposito !== this.props.id_deposito) {
      this.LoadPreds(this.props.id_deposito)
    }
  }

  LoadPreds = async (predId = null) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`pago-deposito/one/${id}`);
    if (!Res.error) {
      this.id_cliente = Res.data.id_cliente;
      let formData = Form.Patch(this.state.FormData, Res.data, true)
      for (const [index] of formData.Fields.entries()) {
        formData.Fields[index].Disabled = Res.data.timbrado;
      }
      formData = await this.formData(formData);
      const { grupos = [] } = Res.data;
      let puedeCanelar = grupos.some(grupo => !grupo.cancelada);
      let puedeTimbrar = grupos.some(grupo => !grupo.fiscal);
      this.setState({
        FormData: formData,
        linea: Res.data.linea,
        restante: parseFloat(Res.data.restante),
        timbrado: grupos.length > 0 && grupos.some(g => g.fiscal),
        id_cliente: Res.data.id_cliente,
        fiscal: Res.data.fiscal,
        disabled: grupos.length > 0 && !puedeTimbrar, // Cuando ya tiene intento de timbre y puede cancelar
        cancelada: grupos.length > 0 && !puedeCanelar,
        grupos: grupos,
      });
    }
  }

  formData = async (form) => {
    let newForm = form;

    const Res = await Http.get(`pago-deposito/form?${this.id_cliente ? `id_cliente=${this.id_cliente}` : ''}`);


    if (!Res.error) {
      const { clientes, formas_pago, bancos } = Res.data;
      if (`${this.props.id_plazo}` === '1' && `${this.id_cliente}` !== '1')
        clientes.push({ id: 1, cliente: '0 - VARIOS' });
      if (this.id_cliente) {
        this.id_cliente = false;
      }
      newForm = Form.FieldOptions(newForm, 'id_cliente', clientes, 'id', 'cliente');
      // newForm = Form.FieldOptions(newForm, 'id_forma_pago', formas_pago, 'id', 'forma_nombre');
      newForm = Form.FieldOptions(newForm, 'id_banco', bancos, 'id', 'banco_nombre');
    }

    newForm = Form.ValueChange(newForm, {
      id_cliente: this.clienteChange,
      // id_forma_pago: this.formaPagoChange,
    });
    return newForm;
  }

  clienteChange = (field) => {
    this.setState({ id_cliente: field.Value });
    this.id_cliente = field.Value;
  }

  formaPagoChange = (field) => {
    this.setState({ id_forma_pago: field.Value });
    this.id_forma_pago = field.Value;
  }

  onSubmit = async (i, vals) => {
    vals.id = this.props.id_deposito;
    this.setState({
      loading: true
    });
    var Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      const { id } = Res.data;
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true, viewFacuras: true, id });
    } else {
      this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });
    }
  }

  viewFacurasClose = async () => {
    await this.LoadPreds(this.props.id_deposito)
    this.setState({ viewFacuras: false })
  }

  onTimbrar = async () => {
    const { id_forma_pago } = this.state;
    this.setState({ timbranding: true });
    const Resp = await Http.post(`deposito/timbrar`, { id: this.props.id_deposito, id_forma_pago });
    if (Resp.error) {
      Snackbar(Resp.errMsg);
      return;
    }
    this.setState({
      deposito: { id: this.props.id_deposito },
      viewPdf: true,
    });
    this.setState({ timbranding: false });
  }

  viewPdfClose = () => {
    this.setState({ viewPdf: false });
    this.LoadPreds(this.props.id_deposito);
  };

  handledownloadPdf = () => {
    const { pdfURL } = this.state;
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = pdfURL;
    a.download = `factura.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(pdfURL);
  }

  handledownloadFile = async (type) => {
    const { FormData } = this.state;
    const id_guia = FormData.Fields[0].Value;
    const Resp = await Http.post("facturacion/file", { id_guia, type }, true, "arraybuffer");
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `${this.props.id_deposito || "Depósito_XML"}.xml`;
      // a.download = `${id_guia}.xml`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  handleSendEmail = async () => {
    this.setState({ viewPdf: true })
  }

  onCancelarFactura = () => {
    // this.setState({ cancelDialog: { visible: true } });
    this.validarFacturaAntesCancelar();
  }

  validarFacturaAntesCancelar = async () => {
    const { id_deposito } = this.props;
    this.setState({ preCancelLoading: true });
    try {
      let Res = await Http.post(`deposito/${id_deposito}/verificar-cancelacion`);
      if (!Res.error) {
        if (Res.data.length > 1)
          this.setState({
            preCancelDialog: {
              grupos: Res.data,
              visible: true,
            },
            preCancelLoading: false,
          })
        else {
          this.onCancelarFacturaElegida(Res.data[0]);
        }
      }
      else {
        this.setState({ sbMsg: `Error al cancelar: ${Res.errMsg}`, sbOpen: true, preCancelLoading: false });
      }
      this.setState({ cancelDialog: { visible: false, preCancelLoading: false } });
    } catch (error) {
      console.error(error);
    }
  }

  onCancelarFacturaElegida = (grupo) => {
    console.log(grupo)
    this.cancelarFactura(grupo.id);
  }

  cancelarFactura = async (id_grupo) => {
    const { cancelada, cancelDialog, preCancelDialog } = this.state;
    const { id_deposito } = this.props;
    if (cancelada > 0) return;
    this.setState({ cancelDialog: { ...cancelDialog, loading: true }, preCancelDialog: { ...preCancelDialog, loading: true } });
    try {
      let Res = await Http.post(`deposito/${id_deposito}/cancelar/${id_grupo}`);
      if (!Res.error) {
        this.setState({ sbMsg: 'Depósito cancelado', sbOpen: true, preCancelLoading: false });
        this.LoadPreds(this.props.id_deposito);
      }
      else {
        this.setState({ sbMsg: `Error al cancelar: ${Res.errMsg}`, sbOpen: true, preCancelLoading: false });
      }
      this.setState({ cancelDialog: { visible: false }, preCancelDialog: { visible: false } });
    } catch (error) {
      console.error(error);
    }
  }

  onRecalcularRestante = async () => {
    this.setState({ loadingRecalculo: true });
    try {
      let Res = await Http.get(`pago-deposito/recalcular/${this.props.id_deposito}`);
      if (!Res.error) {
        this.setState({ sbMsg: 'Depósito recalculado correctamente', sbOpen: true, loadingRecalculo: false });
        this.LoadPreds(this.props.id_deposito);
      } else {
        this.setState({ sbMsg: `Error al recalcular: ${Res.errMsg}`, sbOpen: true, loadingRecalculo: false });
      }
    } catch (error) {
      this.setState({ loadingRecalculo: false });
      console.error(error);
    }
  }

  render() {
    const { id_cliente, viewFacuras = false, id, linea, restante, viewPdf,
      timbrado, timbranding = false, cancelada, cancelDialog = {},
      preCancelDialog = {}, preCancelLoading = false, grupos = [], loadingRecalculo = false,
    } = this.state
    const { id_plazo, id_deposito } = this.props;
    const { hasAccess } = this.context
    return (
      <div>
        <div style={{ marginLeft: 10 }} >
          {((id_plazo == 1 && hasAccess(ACCESS.COBRANZA_APLICACION_PAGOS.TIMBRAR_DEPOSITO_CREDITO)) || (id_plazo == 2 && hasAccess(ACCESS.COBRANZA_APLICACION_PAGOS.TIMBRAR_DEPOSITO_CONTADO))) &&
            <Button
              onClick={() => this.onTimbrar()}
              disabled={!id_cliente || (restante > 10 || restante < -10) || (grupos.length > 0 && grupos.some(g => g.fiscal && !g.cancelada)) || timbranding} variant="contained" color={'primary'} >
              Timbrar {cancelada ? 'nuevamente' : ''}
            </Button>
          }
          {timbrado &&
            <div>
              <Button
                style={{ marginLeft: 5 }}
                variant="contained"
                color={'primary'}
                onClick={this.handleSendEmail}
              >
                Ver archivos
              </Button>

              {hasAccess(ACCESS.COBRANZA_APLICACION_PAGOS.CANCELAR_DEPOSITO) &&
                <Button
                  style={{ marginLeft: 5 }}
                  variant="contained"
                  color={'primary'}
                  onClick={this.onCancelarFactura}
                  disabled={cancelada || preCancelLoading}
                >
                  Cancelar factura
                </Button>
              }
            </div>
          }
          <Button
            style={{ marginLeft: 5 }}
            variant="contained"
            color={'primary'}
            onClick={this.onRecalcularRestante}
          // disabled={timbrado || !id_deposito || loadingRecalculo}
          >
            Recalcular Restante
          </Button>
        </div>
        {
          timbrado && (
            <div style={{ textAlign: 'right', padding: 10 }}>
              {grupos.map((grupo, index) => (
                <div key={index} style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <p><b>Folio fiscal:</b> {grupo.fiscal}</p>
                  {grupo.cancelada > 0 && <p>Factura cancelada</p>}
                </div>
              ))}
            </div>
          )
        }
        {
          id_deposito && !timbrado && (
            <div style={{ textAlign: 'right', padding: 10 }}>
              <p><b>Restante:</b> {(restante !== null && restante !== undefined) ? `$${restante}` : 'Cargando'}</p>
            </div>
          )
        }
        <this.FormRender extraComponent={
          <div>
            {
              id_cliente && <CfdiContacto id_cliente={id_cliente} />
            }
          </div>
        } />
        <Dialog
          onClose={this.viewFacurasClose}
          open={viewFacuras || false}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle onClose={this.viewFacurasClose}>Facturas</DialogTitle>
          <DialogContent dividers>
            <Facturas id={id} linea={linea} id_plazo={id_plazo} />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.viewFacurasClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          onClose={this.viewPdfClose}
          open={viewPdf || false}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle onClose={this.viewPdfClose}>Vista Previa</DialogTitle>
          <DialogContent dividers>
            <DescargarDeposito deposito={{ id: id_deposito }} id_cliente={id_cliente} onClose={this.viewPdfClose} />
          </DialogContent>
        </Dialog>

        <DialogComponent
          open={cancelDialog.visible}
          title={"Confirmar"}
          options={["Sí, cancelar"]}
          onClose={this.onCloseCancelarFactura}
          loading={cancelDialog.loading}
        >
          ¿Cancelar depósito?
        </DialogComponent>

        <DialogComponent
          open={preCancelDialog.visible}
          title={"Confirmar"}
          options={[]}
          onClose={() => this.setState({ preCancelDialog: { ...preCancelDialog, visible: false } })}
          loading={preCancelDialog.loading}
        >
          <p>¿Qué factura se va a cancelar?</p>
          {
            preCancelDialog.grupos && preCancelDialog.grupos.map(grupo => (
              <Button disabled={preCancelDialog.loading} variant='contained' key={grupo.nombre} onClick={() => this.onCancelarFacturaElegida(grupo)}>{grupo.nombre}</Button>
            ))
          }
        </DialogComponent>
      </div>
    )
  }
}

export default withRouter(Deposito)
